import { createTheme } from '@mui/material/styles';

import { COLORS } from './Colors';

export const theme = createTheme({
    palette: {
        primary: {
            main: COLORS.primary,
        },
        secondary: {
            main: COLORS.secondary,
        },
        background: {
            default: COLORS.background_primary
        }
    },
    typography: {
        fontFamily: "'Public Sans', sans-serif;"
    }
});

export const sidebarWidth = 300;

